import { render, staticRenderFns } from "./describe_image.vue?vue&type=template&id=7c6c7480&scoped=true"
import script from "./describe_image.vue?vue&type=script&lang=js"
export * from "./describe_image.vue?vue&type=script&lang=js"
import style0 from "./describe_image.vue?vue&type=style&index=0&id=7c6c7480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c7480",
  null
  
)

export default component.exports